import { useRouteLoaderData } from '@remix-run/react';
import React from 'react';
import { Dropdown } from 'react-bootstrap';

import Icon from '~/components/icons/Icon';
import { setCookie } from '~/utils/cookies.client';
import { useChannelConfig } from '~/utils/useChannelConfig';

/*TODO: vlajky předělat na více component per jazyk nebo tahat z API*/

const CurrencySwitcher = () => {
  const rootData = useRouteLoaderData<typeof import('~/root').loader>('root');
  const currentCurrency = rootData?.channelCode || 'default';

  const channelData = useChannelConfig();
  const currencies = channelData.currencies;

  const switchToCurrency = (currency: { channel: string; currency: string }) => {
    setCookie('channelCode', currency.channel, { maxAge: 31536000 });
    window.location.reload();
  };

  return (
    <Dropdown className="header__switcher header__switcher--currency">
      <Dropdown.Toggle variant="link" className="no-caret">
        <span>{currencies.find((c) => c.channel === currentCurrency)?.currency.toUpperCase()}</span>
        <Icon name="chevron-down" size={20} className="tabler-icon-chevron-down" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-1 mt-1">
        {currencies.map((currency) => (
          <Dropdown.Item
            key={currency.channel}
            active={currentCurrency === currency.channel}
            onClick={() => switchToCurrency(currency)}
          >
            {currency.currency.toUpperCase()}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CurrencySwitcher;
